var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 18H6V5H8V14H7V18ZM6 4H9V7H10V4H13V2H6V4ZM9 8V15H8V18H11V15H10V8H9ZM15 3V4H18V3H15ZM15 9H18V8H15V9ZM15 14H18V13H15V14ZM15 19H18V18H15V19ZM11 5V14H12V18H13V5H11ZM9.42 23H9.58L13 19H6L9.42 23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipment);
export default __webpack_public_path__ + "static/media/equipment.f987eb7449aaee827b66644348e751cc.svg";
export { ForwardRef as ReactComponent };